import { render, staticRenderFns } from "./registryChange.vue?vue&type=template&id=adcdf4bc&scoped=true&"
import script from "./registryChange.vue?vue&type=script&lang=js&"
export * from "./registryChange.vue?vue&type=script&lang=js&"
import style0 from "./registryChange.vue?vue&type=style&index=0&id=adcdf4bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adcdf4bc",
  null
  
)

export default component.exports